var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup62(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_62",
    "data-name": "Group 62",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.593,
    height: 50.591,
    viewBox: "0 0 50.593 50.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M156.533,4.745A2.966,2.966,0,1,0,159.5,7.711a2.965,2.965,0,0,0-2.966-2.966",
    transform: "translate(-117.844 4.289)",
    fill: "#121f55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M154.117,6.742A12.46,12.46,0,1,0,166.578,19.2,12.475,12.475,0,0,0,154.117,6.742m0,20.44A7.981,7.981,0,1,1,162.1,19.2a7.986,7.986,0,0,1-7.979,7.979",
    transform: "translate(-128.612 6.094)",
    fill: "#121f55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M170.2,50.591H150a15.215,15.215,0,0,1-15.2-15.2V15.2A15.213,15.213,0,0,1,150,0h20.2a15.213,15.213,0,0,1,15.2,15.2v20.2a15.215,15.215,0,0,1-15.2,15.2M150,4.76A10.447,10.447,0,0,0,139.567,15.2v20.2A10.45,10.45,0,0,0,150,45.833h20.2a10.451,10.451,0,0,0,10.437-10.439V15.2A10.448,10.448,0,0,0,170.2,4.76Z",
    transform: "translate(-134.805)",
    fill: "#121f55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup62);
export default __webpack_public_path__ + "static/media/Group 62.248b3ca4f8e8605009b655808d7f3add.svg";
export { ForwardRef as ReactComponent };